/* eslint-disable no-param-reassign */
import _ from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import Container from 'components/Containers/Container';
import Card from 'components/Containers/Card';
import { Button, Row, Col } from 'reactstrap';

import { queryFirst } from 'helpers/QueryHelper';
import { start } from 'modules/Olympic/actions';
import { notification, Select } from 'antd';

const { Option } = Select;

const examinations = [];

const classData = [
  { value: 1, name: 'Lớp 1' },
  { value: 2, name: 'Lớp 2' },
  { value: 3, name: 'Lớp 3' },
  { value: 4, name: 'Lớp 4' },
  { value: 5, name: 'Lớp 5' },
];

for (let i = 1; i <= 135; i++) {
  examinations.push(i);
}

const OlympicPracticeDefault = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const level = localStorage.getItem('classLevel');
  const [classLevel, setClassLevel] = React.useState(level ?? 4);

  const onChange = (value) => {
    setClassLevel(value);
    localStorage.setItem('classLevel', value);
  };

  const renderSelect = () => {
    return (
      <Select
        showSearch
        style={{ width: 100 }}
        optionFilterProp="children"
        onChange={onChange}
        defaultValue={parseInt(classLevel)}
        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
      >
        {classData.map((item) => <Option key={item.value} value={item.value}>{item.name}</Option>)}
      </Select>
    );
  };

  const renderTitle = () => {
    return (
      <div className="d-flex justify-content-between align-items-center">
        <div>Olympic English</div>
        <div>
          {renderSelect()}
        </div>
      </div>
    );
  };

  return (
    <Container name='Trang chủ' parentName="Olympic English">
      <Card title={renderTitle()}>
        <h1>{`Chọn đề thi ngẫu nhiên lớp ${classLevel}`}</h1>
        <Row className='d-flex flex-wrap'>
          {examinations.map((e) => {
            return (
              <Col key={e} className='p-4'>
                <Button
                  style={{ width: 200 }}
                  className='text-nowrap'
                  color='primary'
                  onClick={async () => {
                    const originalExamination = await queryFirst('p_SACHSO_OLYMPIC_DETHI_Get', { classLevel, examinationCode: e }, 'SGK');

                    // const originalExamination = await queryFirst('p_SACHSO_OLYMPIC_DETHI_Get', { classLevel: 4, examinationCode: e }, 'SmartEducation');
                    const examination = _.cloneDeep(originalExamination);
                    if (!examination) return notification.warning({ message: 'Không có câu hỏi để hiển thị !' });
                    // FIXED
                    examination.questions.forEach((q) => {
                      if (_.startsWith(q.answers, '[{')) {
                        q.answers = JSON.parse(q.answers);
                      }

                      if (_.startsWith(q.settings, '{')) {
                        q.settings = JSON.parse(q.settings);
                      }
                    });

                    // console.log('Examination: ', examination);

                    dispatch(start(examination));
                    return history.push(`/lms/olympic/examination/${e}/start/1`);
                  }}
                >
                  Đề thi số
                  {' '}
                  {e}
                </Button>
              </Col>
            );
          })}
        </Row>
      </Card>
    </Container>
  );
};
export default OlympicPracticeDefault;
